<template>
  <div class="view-product-register-module-group">
    <register-group
      v-if="!$route.params.group"
      :product-id="$route.params.id"
    />

    <action-dispatcher
      v-else
      action="membersGroups/getDetails"
      :parameters="$route.params.group"
    >
      <register-group :group="group" :product-id="$route.params.id" />
    </action-dispatcher>
  </div>
</template>

<script>
import RegisterGroup from "@/components/product/details/content/RegisterGroup";
import { mapState } from "vuex";

export default {
  components: { RegisterGroup },
  computed: {
    ...mapState("membersGroups", ["group"])
  }
};
</script>
